<template>
  <div class="cancel-visit-summary">
    <div class="cancel-visit-summary__infos cvsi">
      <deal-timeline-message-avatar :user="interlocutor" />
      <div class="cvsi__seller cvsi-seller">
        <div class="cvsi-seller__name">
          <label>
            {{ fullName }}
          </label>
        </div>
        <div class="cvsi-seller__organization">
          {{ organizationName }}
        </div>
      </div>
    </div>
    <div class="cancel-visit-summary__content cvsc">
      <span class="cvsc__divider" />
      <div class="cvsc__deal cvsc-deal">
        <div class="cvsc-deal__date cvsc-deal-date">
          <span class="cvsc-deal-date__icon" />
          <span>{{ visitedDate }}</span>
        </div>
        <div
          v-if="isSeller"
          class="cvsc-deal__alias cvsc-deal-alias"
        >
          <span class="cvsc-deal-alias__icon" />
          <span
            class="cvsc-deal-alias__link"
            @click="clickToOffer"
          >
            {{ offerName }}
          </span>
        </div>
        <div class="cvsc-deal__address cvsc-deal-address">
          <span class="cvsc-deal-address__icon" />
          <span
            class="cvsc-deal-address__link"
            @click="clickToMaps"
          >
            {{ dealAddress }}
          </span>
        </div>
        <p
          v-if="accessInfos"
          class="cvsc-deal__key"
        >
          {{ accessInfos }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getDealAddress, redirectToMaps } from '@elements/address-utils';
import { momentMixin } from '@tools/moment';
import { translationMixin } from '@elements/translation';
import { messagingMixins } from '@pages/inbox/mixins';
import DealTimelineMessageAvatar from '@pages/inbox/conversations-show/TimelineElements/Avatar.vue';

export default {
  components: { DealTimelineMessageAvatar },
  mixins: [ messagingMixins, momentMixin, translationMixin ],
  props: {
    deal: { type: Object, required: true },
    interlocutor: { type: Object, required: true },
    isSeller: { type: Boolean, default: true },
  },
  computed: {
    accessInfos() {
      if (!this.deal || !this.deal.first_office_offer) {
        return null;
      }

      return this.deal.first_office_offer.access_infos !== undefined ? this.deal.first_office_offer.access_infos : null;
    },
    fullName() {
      return this.getUserFullName(this.interlocutor);
    },
    dealAddress() {
      return getDealAddress(this.deal);
    },
    offerName() {
      return this.deal.first_office_offer.name;
    },
    organizationName() {
      return this.interlocutor.organization.name;
    },
    visitedDate() {
      return this.deal.visited_date === null ? '' : this.getReadableDate(this.deal.visited_date.iso, ' à', true);
    },
  },
  methods: {
    clickToOffer() {
      window.open(this.deal.first_office_offer.url, '_blank');
    },
    clickToMaps() {
      if (this.dealAddress) {
        redirectToMaps(this.dealAddress);
      }
    },
  },
};
</script>
